<template lang="pug">
  section(class="jumbo")
    .video
      video(src="content/loop-ford.mp4" muted autoplay loop playsinline)
    .jumbo-wrapper
      .jumbo-figure
        h1 FORD RANGER 2019
          small La nueva Ranger 2019 ha sido desarrollada y probada según estándares exigentes de la filosofía Hecha con Fuerza Ford. Comparte con las Camionetas Ford una herencia de resistencia, durabilidad y capacidad obtenida con más de 100 años de esfuerzos centrados en lograr la excelencia en el campo de la ingeniería.
</template>

<script>
  export default  {
    name: 'jumbo',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .jumbo {
    max-height: 90vh;
    overflow: hidden;
    position: relative;
    @media all and (max-width: 800px){
      min-height: 80vh;
    }
  }
  .video{
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0;
    height: 0;
    @media all and (max-width: 800px){
      min-height: 80vh;
      padding: 0;
      height: auto;
    }
    &:before{
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url(../assets/grid.png);
      position: absolute;
      z-index: 2;
    }
    iframe,
    video{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      @media all and (max-width: 800px){
        object-fit: cover;
      }
    }
  }
  .jumbo-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .jumbo-figure{
    max-width: 70%;
    text-align: center;
  }
  h1{
    color: white;
    font-family: 'Lato', sans-serif;
    font-weight: 900;
    font-size: 5rem;
    @media all and (max-width: 800px){
      font-size: 3rem;
    }
    small {
      display: block;
      font-size: 2rem;
      @media all and (max-width: 800px){
        font-size: 1.2rem;
      }
    }
  }
</style>
